import React from 'react'

import { formatMoney } from 'common/moneyFormatter'

import './SummaryItem.less'

export interface SummaryItemProps {
  label: string
  value: number
  defaultColorsOverride?: string
}

const SummaryItem: React.FC<SummaryItemProps> = ({ label, value, defaultColorsOverride: colorOverride }) => {
  const overrideStyle = {
    color: colorOverride ? colorOverride : '',
  }

  return (
    <div className="summary_item">
      <label className="summary_item_label" style={overrideStyle}>
        {label}
      </label>
      <h5 className="summary_item_value" style={overrideStyle}>
        {formatMoney(value)}
      </h5>
    </div>
  )
}

export default SummaryItem
